// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2Mb4n","info":"UpdateTermsInfo_info__13fLz"};